import { ResourceDetails } from '../common';

export enum GcpVmAction {
  START = 'start',
  STOP = 'stop',
  RESTART = 'restart',
}

export type GcpVmActionType =
  | GcpVmAction.START
  | GcpVmAction.STOP
  | GcpVmAction.RESTART;

export enum GcpVmState {
  PENDING = 'PENDING',
  PROVISIONING = 'PROVISIONING',
  STAGING = 'STAGING',
  RUNNING = 'RUNNING',
  PENDING_STOP = 'PENDING_STOP',
  STOPPING = 'STOPPING',
  TERMINATED = 'TERMINATED',
  REPAIRING = 'REPAIRING',
  SUSPENDING = 'SUSPENDING',
  SUSPENDED = 'SUSPENDED',
  UNKNOWN = 'unknown',
}

// TODO: Add more column needed
export interface GcpVmResourceDetails extends ResourceDetails {
  status: GcpVmState;
  zone: string;
  machineType: string;
}
